import Button from './SearchBar.component';

export default Button;